import React, { useEffect, useState } from 'react'
import './purifier-page.scss'
import SinglePage from '../../components/common/page/SinglePage'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Modal from '../../components/common/modal/Modal'
import ChooseForPurifier from '../../components/user/choose-purifier-service/ChooseForPurifier'



const PurifierPage = () => {
    const navigate = useNavigate()
    const [modal, setModal] = useState({ content: null, title: null, status: false })


    return (
        <div className="purifier-page-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Purifier']}>
                <div className="border">

                    <div className="button-div" >
                        <button onClick={() => setModal({ content: <ChooseForPurifier setModal={setModal} />, title: 'Choose Date', status: true })} >
                            PURIFIER SERVICES LIST</button>
                    </div>
                    <div className="button-div" >
                        <button onClick={() => navigate('/purifier/spares-list')} >SPARES LIST
                        </button>
                    </div>
                    <div className="button-div" >
                        <button onClick={() => navigate('/purifier/product-list')} >PRODUCT LIST
                        </button>
                    </div>

                </div>
            </SinglePage >
        </div>
    )
}

export default PurifierPage